import React, { ElementType } from 'react';
import { Link } from 'react-router-dom';
import { Shelf } from '@src/remotes/Shelf';
import { useBookmarkActions } from '@src/hooks';
import { ShimmerLoader } from '@guildeducationinc/recess';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { getUserValuesForPath } from '@src/constants/getUserValuesForPath';
import { useBookmarks } from '../Providers/BookmarksProvider';
import { BookmarksCallout } from '../BookmarksCallout';
import styles from './BookmarksShelf.module.scss';

export const BookmarksShelf: React.FC = () => {
	const { bookmarks, bookmarksLoading } = useBookmarks();
	const { updateBookmark } = useBookmarkActions();
	const { getAccessToken, getIdToken, userFromIdToken: user } = useMemberExperienceAuth();
	const authUser = getUserValuesForPath(user);

	if (bookmarksLoading)
		return <ShimmerLoader height={350} label='Bookmarks Loading' loaded={false} />;

	if (!bookmarks?.length) return <BookmarksCallout />;

	const bookmarkedProgramUuids = bookmarks.map(bookmark => bookmark.uuid);

	return (
		<div className={styles.bookmarksShelf} data-testid='bookmarks-shelf'>
			<Shelf
				LinkComponent={Link as unknown as ElementType}
				bookmarks={bookmarks}
				getAccessToken={getAccessToken}
				getIdToken={getIdToken}
				product='catalog'
				programUuids={bookmarkedProgramUuids}
				shelfType='bookmarks_shelf'
				subhead="Add bookmarks to your favorite programs and find them here until you're ready to apply."
				updateBookmark={updateBookmark}
				user={authUser}
			/>
		</div>
	);
};
